<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div>
      <Datepicker
          v-bind="$attrs"
          format="MM/dd/yyyy"
          :name="question.name"
          :id="question.name"
          ref="calendarPicker"
          input-class="waffle-text-input border-0 fw-bold"
          v-maska="'##/##/####'"
          v-model="dateInput"
          @update:modelValue="dateSelected"
          class="waffle-hover-border waffle-calendar-input-container waffle-text-input-container w-100 mx-0 px-0"
          :class="{
            'waffle-invalid-border waffle-invalid-color':error && hasBeenInteractedWith,
            'border-setup': !hasBeenInteractedWith}"
          :typeable="true"
          :calendar-button="true"
          :calendar-button-icon="'bi calendar-icon'"
          :full-month-name="true"
          :disabled="disabled"
          :disabledDates="availableDates"
          :preventDisableDateSelection="true"
          :open-date="
        dateInput ||
        (availableDates.from && availableDates.from < new Date()
          ? availableDates.from
          : new Date())
      "
          @focusin="isCurrentlyFocused = true; $event.target.setSelectionRange(dateInput?.length, dateInput?.length);"
          @focusout="isCurrentlyFocused = false; $emit('user-interaction')"
      >
      </Datepicker>
      <span :class="{'waffle-float-label':isCurrentlyFocused || dateInput}" class="waffle-text-placeholder placeholder-wrap">
      {{ forcePromptPlaceholder ? question.prompt : (question.placeholder || question.prompt) }}
    </span>
    </div>
    <slot name="helptext" :isError="error" :isConfirm="!disableConfirm && (question?.value && question?.prefilled) && !error"
          :confirmCb="() => { $emit('user-interaction'); $emit('confirm');}"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="dateInput ? (typeof dateInput !== 'string' ? momentFormat(dateInput).format('MM/DD/yyyy'):momentFormat(dateInput,'YYYYMMDD').format('MM/DD/yyyy')):'-'"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>

<script>
import Datepicker from "vuejs3-datepicker";
import moment from "moment";
import ReadOnly from "@/components/themeable-components/ReadOnly.vue";

export default {
  name: "CalendarDatePicker",
  emits: ["update:modelValue", "field-error",'confirm','user-interaction'],
  props: {
    disableConfirm:Boolean,
    question: {
      type: Object,
      required: true,
    },
    hideSubText: {
      type: Boolean,
    },
    skipEagerValidation: {
      type: Boolean,
    },
    forcePromptPlaceholder: {
      type: Boolean,
    },
    hasBeenInteractedWith:Boolean,
    disabled: Boolean
  },
  components: {
    ReadOnly,
    Datepicker,
  },
  data() {
    return {
      dateInput: "",
      dateRange:
          this.question?.criteria?.find((el) => typeof el === "object")?.[
              "range"
              ] ?? [],
      error: "",
      isCurrentlyFocused: false,
    };
  },
  mounted() {
    const calendarInput = this.$refs.calendarPicker?.$el.querySelector('.internalInput')
    if(calendarInput){
      calendarInput.inputMode = 'numeric';
    }

    if (this.question.value) {
      this.dateInput = moment(this.question.value, "YYYYMMDD").toDate();
    }
    if (!this.skipEagerValidation) {
      this.error = this.question.error;
      if (!this.error && this.question?.required && !this.dateInput) {
        this.error = "Required";
      }
      if (this.error) {
        this.$emit("field-error", true);
      }
      // else {
      //   this.$emit("field-error", false);
      // }
    }
  },
  watch: {
    question: {
      handler(newQuestion) {
        if (newQuestion.error) {
          this.error = newQuestion.error;
          return this.$emit("field-error", true);
        }
        if (newQuestion.value && newQuestion.value !== moment(this.dateInput).format("YYYYMMDD")) {
          this.dateSelected(moment(newQuestion.value, "YYYYMMDD").toDate())
        }
      },
      deep: true,
    },
  },
  computed: {
    momentFormat(){
      return moment
    },
    availableDates() {
      return {
        from: this.dateRange[1] ? new Date(this.dateRange[1]?.split('T')[0]) : null, //max
        to: this.dateRange[0]  ? new Date(this.dateRange[0]?.split('T')[0]) : null, //min
      };
    },
  },
  methods: {
    //jest param is here due to mocking of Datepicker
    dateSelected(payload, jest=false) {
      this.$nextTick(() => {
        this.dateInput = payload;
        const trueInputValue = document.querySelector(`#${this.question.name}`)?.value

        if(!jest && !trueInputValue?.split('/')?.every((el, i) => (el.length === 2 && i < 2) || (el.length === 4 && i === 2 && el !== '0000'))){
          this.error="Invalid Date"
          return this.$emit("field-error", true);
        }

        if (!payload && this.question.required) {
          this.error = "Required";
          return this.$emit("field-error", true);
        }
        const selectedDate = moment(payload);
        if (
            this.dateRange.length &&
            !selectedDate.isBetween(
                this.availableDates.to,
                this.availableDates.from
            )
        ) {
          this.error = "Not a valid date";
          return this.$emit("field-error", true);
        }

        this.error = "";

        this.$emit("field-error", false);
        this.$emit('user-interaction');
        return this.$emit("update:modelValue", selectedDate.format("YYYYMMDD"));
      })
    },
  },
};
</script>
